module.exports = __webpack_public_path__ + "img/driver.6212bf5b.svg";